import React, { useEffect, useRef, useState } from 'react';
import { INSTAGRAM } from '../mock';
import { subscribeEmail } from '../api';

export function Logo({ size = 'nav' }) {
  const foot = size === 'foot';
  return (
    <span className={`brand-logo sz-${foot ? 'foot' : 'nav'}`}>
      <img
        src={foot ? '/brand/logo/monogram-green.png' : '/brand/logo/wordmark-green.png'}
        alt="South Beach Blooms"
        className={foot ? 'brand-logo-monogram' : 'brand-logo-wordmark'}
        data-testid={foot ? 'footer-logo' : 'nav-logo-img'}
      />
      {!foot && <span className="brand-logo-sub">Torquay Flower Farm</span>}
    </span>
  );
}


const PILLARS = [
  { ic: '/brand/ic-pot.png', t: 'Locally Grown', d: 'We grow our flowers right here in Torquay.' },
  { ic: '/brand/ic-sun.png', t: 'Seasonal Beauty', d: 'Sustainable blooms that celebrate every season.' },
  { ic: '/brand/ic-hand.png', t: 'Grown with Love', d: 'From our little farm to your home.' },
  { ic: '/brand/ic-barn.png', t: 'Support Local', d: 'Supporting our community and small business.' },
];

export function Pillars() {
  return (
    <div className="pillars-breaker">
      {PILLARS.map((p, i) => (
        <div className="fpil rev" key={i}>
          <img src={p.ic} alt="" className="fpil-ic" />
          <div className="fpil-t">{p.t}</div>
          <p className="fpil-d">{p.d}</p>
        </div>
      ))}
    </div>
  );
}


// Reveal-on-scroll hook — observes .rev elements and adds .in
export function useReveal(deps = []) {
  useEffect(() => {
    const items = document.querySelectorAll('.rev:not(.in)');
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const parent = e.target.closest('section,div,article,footer');
            const siblings = parent ? [...parent.querySelectorAll('.rev')] : [];
            const idx = siblings.indexOf(e.target);
            setTimeout(() => e.target.classList.add('in'), Math.min(idx * 60, 280));
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    items.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export const IG = () => (
  <svg viewBox="0 0 24 24"><path d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.256 1.216.598 1.772 1.153.509.5.902 1.105 1.153 1.772.248.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122s-.01 3.056-.06 4.122c-.05 1.065-.217 1.79-.465 2.428a4.883 4.883 0 01-1.153 1.772c-.5.508-1.105.902-1.772 1.153-.637.248-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06s-3.056-.01-4.122-.06c-1.065-.05-1.79-.217-2.428-.465a4.89 4.89 0 01-1.772-1.153 4.904 4.904 0 01-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12s.01-3.056.06-4.122c.05-1.066.217-1.79.465-2.428a4.89 4.89 0 011.153-1.772A4.897 4.897 0 015.45 2.525c.637-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 100 10 5 5 0 000-10zm0 8.25a3.25 3.25 0 110-6.5 3.25 3.25 0 010 6.5zm5.24-8.78a1.17 1.17 0 100-2.34 1.17 1.17 0 000 2.34z" /></svg>
);
export const FB = () => (
  <svg viewBox="0 0 24 24"><path d="M13.5 21v-8.1h2.7l.4-3.2h-3.1V7.7c0-.9.3-1.6 1.7-1.6h1.6V3.2C16.5 3.1 15.4 3 14.2 3c-2.6 0-4.4 1.6-4.4 4.5v2.2H7v3.2h2.8V21h3.7z" /></svg>
);
export const TT = () => (
  <svg viewBox="0 0 24 24"><path d="M16.6 5.82a4.28 4.28 0 01-3.14-1.36V15.4a5.4 5.4 0 11-4.66-5.35v2.5a2.9 2.9 0 102.16 2.8V2h2.5a4.28 4.28 0 001.14 2.86 4.27 4.27 0 003 1.24v2.5a6.75 6.75 0 01-1-.08V5.82z" /></svg>
);

// Email join form with success state
export function JoinBlock({ eyebrow, headline, body, submitLabel = 'Join the List' }) {
  const [val, setVal] = useState('');
  const [done, setDone] = useState(false);
  const submit = async () => {
    if (!val.includes('@')) return;
    setDone(true); const email = val; setVal('');
    try { await subscribeEmail(email, 'join-block'); } catch (e) { /* still show success */ }
    setTimeout(() => setDone(false), 2600);
  };
  return (
    <div className="join-block">
      <div>
        <span className="jb-eyebrow">{eyebrow}</span>
        <h2 className="jb-headline" dangerouslySetInnerHTML={{ __html: headline }} />
        <p className="jb-body">{body}</p>
      </div>
      <div className="jb-form">
        <div className="jb-row">
          <input className="jb-input" placeholder="your@email.com" value={val} onChange={(e) => setVal(e.target.value)} />
          <button className="jb-submit" style={done ? { background: 'var(--forest)', color: '#fff' } : {}} onClick={submit}>
            {done ? "You're on the list! ✦" : submitLabel}
          </button>
        </div>
        <p className="jb-note">No spam. Unsubscribe any time.</p>
      </div>
    </div>
  );
}

export function InstagramSection({ eyebrow = 'Follow along daily' }) {
  return (
    <div className="ig-section">
      <div className="ig-header">
        <span className="eyebrow rev">{eyebrow}</span>
        <h2 className="ig-headline rev">Follow along on Instagram</h2>
        <a className="ig-handle rev" href="https://instagram.com/southbeachblooms" target="_blank" rel="noreferrer">@southbeachblooms · Daily updates from the farm</a>
      </div>
      <div className="ig-grid">
        {INSTAGRAM.map((src, i) => (
          <div className="ig-tile" key={i}>
            <div className="ig-tile-inner bg-photo" style={{ backgroundImage: `url(${src})` }} />
            <div className="ig-tile-ov">♡</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Ticker({ items }) {
  const track = [...items, ...items];
  return (
    <div className="ticker" aria-hidden="true">
      <div className="ticker-track">
        {track.map((t, i) => (
          <span className="ticker-item" key={i}>{t}<span className="ticker-dot">✦</span></span>
        ))}
      </div>
    </div>
  );
}

export function FAQ({ items, title = 'Want to Know More?', eyebrow = 'Common Questions' }) {
  const [open, setOpen] = useState(-1);
  return (
    <div className="faq-section">
      <span className="eyebrow rev" style={{ textAlign: 'center', display: 'block' }}>{eyebrow}</span>
      <h2 className="rev serif-h" style={{ textAlign: 'center' }}>{title}</h2>
      <div style={{ marginTop: 32 }}>
        {items.map((f, i) => (
          <div className={`faq-item rev${open === i ? ' open' : ''}`} key={i}>
            <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)}>{f.q}<span className="faq-q-icon">+</span></button>
            <div className="faq-a"><p>{f.a}</p></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function JoinFull({ eyebrow, headline, body }) {
  const [val, setVal] = useState('');
  const [done, setDone] = useState(false);
  const submit = async () => {
    if (!val.includes('@')) return;
    setDone(true); const email = val; setVal('');
    try { await subscribeEmail(email, 'join-full'); } catch (e) { /* still show success */ }
    setTimeout(() => setDone(false), 2600);
  };
  return (
    <div className="join-full" id="join-tubers">
      <span className="eyebrow eyebrow-rose rev" style={{ display: 'block', textAlign: 'center' }}>{eyebrow}</span>
      <h2 className="jf-headline rev" dangerouslySetInnerHTML={{ __html: headline }} />
      <p className="jf-body rev">{body}</p>
      <div className="jf-form rev">
        <input className="jf-input" placeholder="your@email.com" value={val} onChange={(e) => setVal(e.target.value)} />
        <button className="jf-btn" style={done ? { background: 'var(--forest)', color: '#fff' } : {}} onClick={submit}>{done ? "You're in! ✦" : 'Join the Community'}</button>
      </div>
      <p className="jf-note rev">No spam. Unsubscribe any time.</p>
      <div className="jf-perks rev">
        <span className="jf-perk">First access to tubers</span>
        <span className="jf-perk">Farm stand updates</span>
        <span className="jf-perk">Growing tips</span>
        <span className="jf-perk">Behind the scenes</span>
      </div>
    </div>
  );
}

export function PageHeader({ eyebrow, title, sub, cta, ctaPink, onCta, bg, credit }) {
  return (
    <div className={`page-header${bg ? ' has-bg' : ''}`} style={bg ? { backgroundImage: `url(${bg})` } : undefined}>
      <span className="page-header-eyebrow">{eyebrow}</span>
      <h1 className="page-header-title">{title}{sub && <em>{sub}</em>}</h1>
      {cta && <button className={`page-header-cta${ctaPink ? ' pink' : ''}`} onClick={onCta}>{cta}</button>}
      {credit && <a className="page-header-credit" href={credit.href} target="_blank" rel="noreferrer" data-testid="header-photo-credit">{credit.text}</a>}
    </div>
  );
}
